import React from 'react'
import Footer from '../../layout/Footer'
import Header from '../../layout/Header'
import Dashboardmain from '../../components/dashboard/dashboard'

const Dashboard = () => {
    return (
        <>
            <Header />
            <Dashboardmain />
            <Footer />
        </>
    )
}

export default Dashboard